import { createClient } from '@supabase/supabase-js'

const CURRENT_SUITE_SUPABASE_URL = 'https://hjcwkonzfonxltahbwag.supabase.co'
const CURRENT_SUITE_PUBLISHABLE_KEY = 'sb_publishable_zrWTUzkY3FZMRjaO3PjGMA_KQ-uP1DM'

const configuredUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined
const configuredPublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined

function isCloudflarePreview() {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname
  return host.endsWith('.suite-atendimento.pages.dev') && host !== 'suite-atendimento.pages.dev'
}

const usePreviewProxy = isCloudflarePreview()
const supabaseUrl = usePreviewProxy ? CURRENT_SUITE_SUPABASE_URL : configuredUrl
const supabasePublishableKey = usePreviewProxy
  ? CURRENT_SUITE_PUBLISHABLE_KEY
  : configuredPublishableKey

async function previewAwareFetch(input: RequestInfo | URL, init?: RequestInit) {
  if (!usePreviewProxy) return fetch(input, init)

  const targetUrl = input instanceof Request ? input.url : String(input)
  if (!targetUrl.startsWith(CURRENT_SUITE_SUPABASE_URL)) return fetch(input, init)

  const proxyUrl = `/api/supabase-proxy?target=${encodeURIComponent(targetUrl)}`

  if (input instanceof Request) {
    const method = input.method.toUpperCase()
    return fetch(proxyUrl, {
      method,
      headers: input.headers,
      body: method === 'GET' || method === 'HEAD' ? undefined : await input.clone().arrayBuffer(),
      signal: input.signal,
      cache: 'no-store',
    })
  }

  return fetch(proxyUrl, {
    ...init,
    cache: 'no-store',
  })
}

export const hasSupabaseConfig = Boolean(supabaseUrl && supabasePublishableKey)

export const supabase = createClient(
  supabaseUrl ?? 'https://placeholder.invalid',
  supabasePublishableKey ?? 'sb_publishable_placeholder',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
    global: {
      fetch: previewAwareFetch,
    },
  },
)
